import * as e from "react";
import * as t from "uitk-react-layout-grid";
import * as n from "uitk-react-layout-flex";
import * as a from "uitk-react-slider";
import * as o from "@egds/react-core/icons";
import * as i from "@egds/react-sponsored-content";
import * as r from "@egds/react-core";
import * as l from "@egds/react-core/utils";
var s = {
    336: () => {}
  },
  u = {};
function c(e) {
  var t = u[e];
  if (void 0 !== t) return t.exports;
  var n = u[e] = {
    exports: {}
  };
  return s[e](n, n.exports, c), n.exports;
}
c.n = e => {
  var t = e && e.__esModule ? () => e.default : () => e;
  return c.d(t, {
    a: t
  }), t;
}, c.d = (e, t) => {
  for (var n in t) c.o(t, n) && !c.o(e, n) && Object.defineProperty(e, n, {
    enumerable: !0,
    get: t[n]
  });
}, c.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
  var e;
  if ("string" == typeof import.meta.url && (e = import.meta.url), !e) throw new Error("Automatic publicPath is not supported in this browser");
  e = e.replace(/#.*$/, "").replace(/\?.*$/, "").replace(/\/[^\/]+$/, "/"), c.p = e;
})();
var d = {};
(() => {
  c.d(d, {
    Eh: () => N,
    mw: () => ae,
    mZ: () => K,
    vZ: () => h,
    tQ: () => X,
    aT: () => j
  });
  const s = (u = {
    Fragment: () => e.Fragment,
    createContext: () => e.createContext,
    createElement: () => e.createElement,
    default: () => e.default,
    forwardRef: () => e.forwardRef,
    useCallback: () => e.useCallback,
    useContext: () => e.useContext,
    useEffect: () => e.useEffect,
    useImperativeHandle: () => e.useImperativeHandle,
    useRef: () => e.useRef,
    useState: () => e.useState
  }, m = {}, c.d(m, u), m);
  var u, m;
  const p = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      UitkLayoutGrid: () => t.UitkLayoutGrid,
      UitkLayoutGridItem: () => t.UitkLayoutGridItem
    }),
    f = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      UitkLayoutFlex: () => n.UitkLayoutFlex
    }),
    y = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      UitkSlider: () => a.UitkSlider
    }),
    h = ({
      src: e,
      zoomHeading: t,
      containerSize: n = 500,
      maxZoom: a = 100,
      sensitivity: o = .01,
      onEdit: i,
      disabled: r = !1,
      onDragEnd: l,
      onZoomEnd: u,
      displayZoomValue: c = !0
    }) => {
      const [d, m] = (0, s.useState)(0),
        [h, v] = (0, s.useState)(!1),
        [g, E] = (0, s.useState)({
          x: 0,
          y: 0
        }),
        b = (0, s.useRef)(null);
      let k, S;
      const x = () => {
          if (b.current) {
            const e = b.current,
              t = e.naturalWidth / e.naturalHeight,
              [a, i] = (e => {
                const t = e < 1,
                  a = n * (t ? 1 : e) * (d * o + 1),
                  i = n * (t ? 1 / e : 1) * (d * o + 1);
                return [Math.max(0, (a - n) / 2), Math.max(0, (i - n) / 2)];
              })(t);
            let r = e.offsetLeft,
              l = e.offsetTop;
            const s = t > 1 ? -(n * t - n) / 2 : 0,
              u = t > 1 ? 0 : -(n / t - n) / 2;
            r > a + s ? r = a + s : r < -a + s && (r = -a + s), l > i + u ? l = i + u : l < -i + u && (l = -i + u), e.style.left = `${r}px`, e.style.top = `${l}px`;
          }
        },
        w = () => {
          const e = b.current;
          if (e) {
            const {
                offsetLeft: t,
                offsetTop: a,
                naturalWidth: r,
                naturalHeight: l
              } = e,
              s = r / l,
              u = d * o + 1,
              c = s < 1;
            S = n * (c ? 1 : s), k = n * (c ? 1 / s : 1);
            const m = Math.min(r / S, l / k),
              p = {
                x: r / 2,
                y: l / 2
              },
              f = n * m / u,
              y = (t - (s > 1 ? -(n * s - n) / 2 : 0)) * m,
              h = (a - (s > 1 ? 0 : -(n / s - n) / 2)) * m,
              v = p.x - f / 2 - y / u,
              g = p.y - f / 2 - h / u,
              E = f,
              b = document.createElement("canvas");
            b.width = E, b.height = E;
            const x = b.getContext("2d");
            if (x) {
              x.drawImage(e, v, g, E, E, 0, 0, E, E);
              const t = "image/jpeg";
              b.toBlob(e => {
                if (e) {
                  const n = new File([e], "cropped-image.jpeg", {
                    type: t
                  });
                  i && i(n);
                } else console.error("Failed to create Blob from Canvas");
              }, t);
            }
          }
        };
      (0, s.useEffect)(() => {
        if (b.current) {
          const e = b.current;
          e.crossOrigin = "anonymous", e.style.transform = `scale(${d * o + 1})`, e.style.transformOrigin = "center center";
        }
        x();
      }, [d]);
      const D = e => {
          if (h) {
            let t, n;
            "touches" in e ? (t = e.touches[0].clientX, n = e.touches[0].clientY) : (t = e.clientX, n = e.clientY);
            const a = t - g.x,
              o = n - g.y;
            if (b.current) {
              const e = b.current;
              e.style.left = `${e.offsetLeft + a}px`, e.style.top = `${e.offsetTop + o}px`;
            }
            E({
              x: t,
              y: n
            });
          }
        },
        C = e => {
          let t, n;
          e.preventDefault(), v(!0), "touches" in e ? (t = e.touches[0].clientX, n = e.touches[0].clientY) : (t = e.clientX, n = e.clientY), E({
            x: t,
            y: n
          });
        },
        G = () => {
          v(!1), x(), w(), l && l();
        },
        I = () => {
          u && u(), w();
        };
      (0, s.useEffect)(() => (h ? (document.addEventListener("mousemove", D), document.addEventListener("mouseup", G), document.addEventListener("touchmove", D), document.addEventListener("touchend", G)) : (document.removeEventListener("mousemove", D), document.removeEventListener("mouseup", G), document.removeEventListener("touchmove", D), document.removeEventListener("touchend", G)), () => {
        document.removeEventListener("mousemove", D), document.removeEventListener("mouseup", G), document.removeEventListener("touchmove", D), document.removeEventListener("touchend", G);
      }), [h, g]);
      const M = {
        width: n,
        height: n,
        backgroundColor: "white",
        position: "relative",
        overflow: "hidden",
        cursor: "all-scroll"
      };
      return s.default.createElement(f.UitkLayoutFlex, {
        justifyContent: "center"
      }, s.default.createElement(p.UitkLayoutGrid, {
        space: "twelve"
      }, s.default.createElement(p.UitkLayoutGridItem, null, s.default.createElement(p.UitkLayoutGrid, {
        style: M,
        "data-testid": "image-container",
        onMouseDown: C,
        onTouchStart: C
      }, e && s.default.createElement("img", {
        style: {
          position: "relative",
          overflow: "visible"
        },
        alt: "Unavailable",
        src: e,
        ref: b,
        onLoad: () => {
          const e = b.current;
          if (e) {
            const t = e.naturalWidth / e.naturalHeight,
              a = t < 1;
            S = n * (a ? 1 : t) * (d * o + 1), k = n * (a ? 1 / t : 1) * (d * o + 1);
            const i = Math.max(0, (S - n) / 2),
              r = Math.max(0, (k - n) / 2);
            e.style.left = `-${i}px`, e.style.top = `-${r}px`, e.style.width = `${S}px`, e.style.height = `${k}px`;
          }
          w();
        },
        crossOrigin: "anonymous"
      }), s.default.createElement("div", {
        style: {
          height: "100%",
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%"
        }
      }, s.default.createElement("div", {
        style: {
          position: "absolute",
          content: "''",
          aspectRatio: "1",
          height: "100%",
          zIndex: 1,
          top: "0",
          left: "50%",
          borderRadius: "50%",
          transform: "translateX(-50%)",
          boxShadow: "0px 0px 0px 145px rgba(0, 0, 0, 0.5)"
        }
      })))), s.default.createElement(p.UitkLayoutGridItem, null, s.default.createElement("div", {
        role: "button",
        "aria-hidden": !t,
        tabIndex: 0,
        onMouseUp: I,
        onTouchEnd: I
      }, s.default.createElement(y.UitkSlider, {
        id: "slider",
        name: "slider",
        min: 0,
        max: a,
        step: 1,
        handleChange: m,
        value: d,
        formatValueForDisplay: e => t ? c ? `${t}: ${e}` : `${t}` : `${e}`,
        disabled: r
      })))));
    };
  h.displayName = "ImageEditor";
  var v = function () {
    return v = Object.assign || function (e) {
      for (var t, n = 1, a = arguments.length; n < a; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, v.apply(this, arguments);
  };
  function g(e, t, n) {
    if (n || 2 === arguments.length) for (var a, o = 0, i = t.length; o < i; o++) !a && o in t || (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
    return e.concat(a || Array.prototype.slice.call(t));
  }
  function E() {
    for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
    for (var n = [], a = "undefined" != typeof window && this === window ? void 0 : this, o = 0, i = e; o < i.length; o++) {
      var r = i[o];
      if (r) {
        var l = typeof r;
        if ("string" === l) {
          var s = r.split(" ");
          a && s.length > 1 ? n.push(E.apply(a, s)) : n.push((null == a ? void 0 : a[r]) || r);
        } else if (Array.isArray(r)) [].concat.apply([], r).filter(Boolean).length && n.push(E.apply(null != a ? a : null, r));else if ("object" === l) if (r.toString === Object.prototype.toString) for (var u in r) ({}).hasOwnProperty.call(r, u) && r[u] && n.push((null == a ? void 0 : a[u]) || u);else n.push(r.toString());
      }
    }
    return n.join(" ");
  }
  Object.create, Object.create, "function" == typeof SuppressedError && SuppressedError;
  var b = s.createContext({
    context: null
  });
  if ("undefined" != typeof document) {
    var k = function () {
        document.body.classList.contains("uitk-no-outline") || (document.body.classList.add("uitk-no-outline"), document.body.removeEventListener("mousedown", k), document.body.addEventListener("keydown", S));
      },
      S = function () {
        document.body.classList.contains("uitk-no-outline") && (document.body.classList.remove("uitk-no-outline"), document.body.removeEventListener("keydown", S), document.body.addEventListener("mousedown", k));
      };
    k();
  }
  var x = c(336),
    w = c.n(x),
    D = new Map([[100, "uitk-type-100"], [200, "uitk-type-200"], [300, "uitk-type-300"], [400, "uitk-type-400"], [500, "uitk-type-500"], [600, "uitk-type-600"], [700, "uitk-type-700"], [800, "uitk-type-800"], [900, "uitk-type-900"]]),
    C = new Map([["regular", "uitk-type-regular"], ["medium", "uitk-type-medium"], ["bold", "uitk-type-bold"]]),
    G = new Map([["left", "uitk-type-start"], ["right", "uitk-type-end"], ["center", "uitk-type-center"]]),
    I = new Map([["wrap", "overflow-wrap"], ["truncate", "truncate"], ["truncate-2-lines", "truncate-lines-2"], ["truncate-3-lines", "truncate-lines-3"], ["truncate-4-lines", "truncate-lines-4"]]),
    M = new Map([["none", "hyphens-none"], ["manual", "hyphens-manual"], ["auto", "hyphens-auto"]]),
    L = (new Map([[1, "uitk-heading-1"], [2, "uitk-heading-2"], [3, "uitk-heading-3"], [4, "uitk-heading-4"], [5, "uitk-heading-5"], [6, "uitk-heading-6"], [7, "uitk-heading-7"], [8, "uitk-heading-8"]]), new Map([[1, "uitk-paragraph-1"], [2, "uitk-paragraph-2"], [3, "uitk-paragraph-3"]]), new Map([["half", "uitk-text-spacing-half"], ["one", "uitk-text-spacing-one"], ["two", "uitk-text-spacing-two"], ["three", "uitk-text-spacing-three"], ["four", "uitk-text-spacing-four"], ["six", "uitk-text-spacing-six"]])),
    A = [["h1", "h1"], ["h2", "h2"], ["h3", "h3"], ["h4", "h4"], ["h5", "h5"], ["h6", "h6"]],
    T = (new Map(A), g(g([], A, !0), [["p", "p"]], !1)),
    z = (new Map(T), new Map([["positive", "uitk-text-positive-theme"], ["negative", "uitk-text-negative-theme"], ["emphasis", "uitk-text-emphasis-theme"], ["default", "uitk-text-default-theme"], ["loyalty", "uitk-text-loyalty-theme"], ["global-loyalty", "uitk-text-global-loyalty-theme"], ["inverse", "uitk-text-inverse-theme"], ["light", "uitk-text-light-theme"], ["standard", "uitk-text-standard-theme"], ["secondary", "uitk-text-secondary-theme"]])),
    $ = new Map([["normal", "uitk-text-white-space-normal"], ["nowrap", "uitk-text-white-space-nowrap"], ["pre", "uitk-text-white-space-pre"], ["pre-wrap", "uitk-text-white-space-pre-wrap"], ["pre-line", "uitk-text-white-space-pre-line"], ["break-spaces", "uitk-text-white-space-break-spaces"]]),
    U = (new Map([["b", "b"], ["em", "em"], ["s", "s"], ["small", "small"], ["i", "i"], ["mark", "mark"], ["strong", "strong"], ["q", "q"], ["sub", "sub"], ["sup", "sup"]]), E.bind(w())),
    B = function (e) {
      var t,
        n = e.align,
        a = e.children,
        o = e.inline,
        i = e.size,
        r = e.spacing,
        l = e.overflow,
        u = e.weight,
        c = e.whiteSpace,
        d = e.className,
        m = e.theme,
        p = void 0 === m ? "default" : m,
        f = e.wordBreak,
        y = void 0 !== f && f,
        h = e.dataTestId,
        g = e.hyphens,
        E = function (e, t) {
          var n = {};
          for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;
            for (a = Object.getOwnPropertySymbols(e); o < a.length; o++) t.indexOf(a[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[o]) && (n[a[o]] = e[a[o]]);
          }
          return n;
        }(e, ["align", "children", "inline", "size", "spacing", "overflow", "weight", "whiteSpace", "className", "theme", "wordBreak", "dataTestId", "hyphens"]),
        k = o && "string" == typeof o,
        S = k || i ? i : 300;
      t = o && "boolean" == typeof o ? "span" : k ? o : "div";
      var x = s.useContext(b).data,
        w = null != x ? x : {},
        A = w.bottomScrimContext,
        T = w.overlayScrimContext,
        B = w.contextClassNames,
        N = U("uitk-text", n && G.get(n), r && L.get(r), l && !o && I.get(l), y && !o && I.get("wrap"), g && M.get(g), !A && S && D.get(S), !A && u && C.get(u), c && $.get(c), A && "in-bottom-scrim", T && "in-overlay-scrim", !(A || T) && p && z.get(p), null == B ? void 0 : B.UitkText, d);
      return a ? s.createElement(t, v({
        className: N
      }, h ? {
        "data-test-id": h
      } : {}, E), a) : null;
    };
  B.displayName = "UitkText";
  const N = ({
    text: e,
    diameter: t = 530
  }) => {
    const n = {
      width: `${t}px`,
      height: `${t}px`,
      borderRadius: "50%",
      display: "flex",
      backgroundColor: "#4d5167",
      justifyContent: "center",
      alignItems: "center"
    };
    return s.default.createElement(p.UitkLayoutGrid, {
      style: n
    }, s.default.createElement(B, {
      size: 900,
      weight: "medium",
      theme: "light"
    }, e));
  };
  N.displayName = "AvatarCustom";
  const O = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      EGDSIcon: () => o.EGDSIcon,
      EGDSIconSize: () => o.EGDSIconSize
    }),
    V = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      VideoCustom: () => i.VideoCustom,
      VideoCustomClickAction: () => i.VideoCustomClickAction
    }),
    F = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      EGDSButtonSize: () => r.EGDSButtonSize,
      EGDSIcon: () => r.EGDSIcon,
      EGDSIconSize: () => r.EGDSIconSize,
      EGDSLayout: () => r.EGDSLayout,
      EGDSLayoutFlex: () => r.EGDSLayoutFlex,
      EGDSSheet: () => r.EGDSSheet,
      EGDSSheetContent: () => r.EGDSSheetContent,
      EGDSSheetTransition: () => r.EGDSSheetTransition,
      EGDSTertiaryButton: () => r.EGDSTertiaryButton,
      EGDSTransparentToolbar: () => r.EGDSTransparentToolbar,
      analyticsTracker: () => r.analyticsTracker
    }),
    j = {
      videoResource: {
        src: "",
        thumbnail: ""
      },
      footerContent: {
        customFooter: void 0,
        controlBarProps: {
          useScrim: !1,
          useDefaultCTAButton: !1,
          hasPlayButton: !1,
          hasMuteButton: !1,
          hasClosedCaptionsButton: !1,
          hasFullscreenButton: !1,
          controlButtonsInactivityTimeout: 3
        }
      },
      preserveAspectRatio: !1,
      videoClickAction: V.VideoCustomClickAction.NONE
    },
    P = {
      display: "inline-flex",
      position: "relative"
    },
    R = {
      display: "flex",
      position: "absolute",
      top: "1.5rem",
      right: "1.5rem",
      zIndex: 2
    },
    _ = {
      display: "flex",
      position: "fixed",
      top: "1.5rem",
      right: "1.5rem",
      zIndex: 2
    },
    H = {
      background: "rgb(0,0,0,0.3)",
      margin: "0 12px",
      color: "white"
    },
    Z = {
      background: "rgb(0,0,0,0.3)",
      color: "white"
    },
    X = (0, s.forwardRef)((e, t) => {
      const n = (0, s.useRef)(null),
        [a, o] = (0, s.useState)(!1),
        [i, r] = (0, s.useState)(!0),
        [l, u] = (0, s.useState)(!1),
        {
          analytics: c
        } = e,
        d = () => {
          n.current && n.current.toggleMuteUnmute(), i ? (r(!1), c?.unmuteAnalytics && (0, F.analyticsTracker)(c?.unmuteAnalytics)) : (r(!0), c?.muteAnalytics && (0, F.analyticsTracker)(c?.muteAnalytics));
        };
      return (0, s.useImperativeHandle)(t, () => ({
        toggleMuteUnmute: () => {
          d();
        },
        setShowControlButtons: e => u(e)
      })), s.default.createElement("div", {
        style: P
      }, l && s.default.createElement("div", {
        style: e.isMobile ? _ : R
      }, e.enablePauseButton && s.default.createElement(F.EGDSTertiaryButton, {
        id: "pause-play-button",
        type: "button",
        onClick: () => {
          console.log("accessibility video gesture controls", e.accessibility), n.current && n.current.togglePlayPause(), a ? (o(!1), c?.playAnalytics && (0, F.analyticsTracker)(c?.playAnalytics)) : (o(!0), c?.pauseAnalytics && (0, F.analyticsTracker)(c?.pauseAnalytics));
        },
        style: H,
        size: F.EGDSButtonSize.MEDIUM,
        "aria-label": a ? e.accessibility?.videoControls?.videoPausedAccessibility : e.accessibility?.videoControls?.videoPlayingAccessibility
      }, s.default.createElement(O.EGDSIcon, {
        name: a ? "play_arrow" : "pause",
        theme: "inverse",
        size: O.EGDSIconSize.MEDIUM
      })), e.enableMuteButton && s.default.createElement(F.EGDSTertiaryButton, {
        id: "mute-unmute-button",
        type: "button",
        onClick: () => {
          e?.muteUnmuteAllVideos ? e.muteUnmuteAllVideos(i) : d();
        },
        style: Z,
        size: F.EGDSButtonSize.MEDIUM,
        "aria-label": i ? e.accessibility?.videoControls?.soundOffAccessibility : e.accessibility?.videoControls?.soundOnAccessibility
      }, s.default.createElement(O.EGDSIcon, {
        name: i ? "volume_off" : "volume_up",
        theme: "inverse",
        size: O.EGDSIconSize.MEDIUM
      }))), s.default.createElement(V.VideoCustom, {
        ref: n,
        ...j,
        ...e,
        onVideoLoading: e => {
          u(!e);
        }
      }));
    });
  X.displayName = "VideoGestureControls";
  var W = s.createContext({
      openedDialogs: [],
      open: function () {},
      close: function () {}
    }),
    Y = function (e) {
      return function (t) {
        return s.createElement(s.Fragment, null, e && t.children);
      };
    },
    q = {
      useDialogControl: function (e, t, n, a) {
        return {
          ComponentFactory: Y(n),
          actions: {
            openDialog: function (e) {
              return a(!0, null == e ? void 0 : e.closeAllDialogs);
            },
            closeDialog: function (e) {
              return a(!1, null == e ? void 0 : e.closeAllDialogs);
            },
            toggleDialog: function (e) {
              return a(!n, null == e ? void 0 : e.closeAllDialogs);
            }
          }
        };
      }
    },
    Q = s.createContext(q);
  const J = c.p + "./styles/egds-one-graph-carousel-vertical-navigation.css",
    K = ({
      children: e,
      isOpen: t = !0,
      isMobile: n = !1,
      startIndex: a = 0,
      onCloseClicked: o,
      onUpClicked: i,
      onDownClicked: r,
      addCarouselElements: l,
      accessibility: u
    }) => {
      const c = "scroll-up",
        d = "scroll-down",
        [m] = (0, s.useState)(s.default.Children.toArray(e)),
        [p, f] = function (e, t, n) {
          void 0 === t && (t = "pwaDialog"), void 0 === n && (n = !0);
          var a = s.useContext(W),
            o = a.openedDialogs,
            i = a.open,
            r = a.close,
            l = s.useContext(Q).useDialogControl,
            u = "".concat(e, "_").concat(t),
            c = o.includes(u),
            d = s.useCallback(function (e, t) {
              t && o.forEach(function (e) {
                r(e);
              }), e ? i(u) : e || t || r(u);
            }, [i, r, u, o]),
            m = l(e, t, c, d, n, void 0);
          return [c, m.actions, m.ComponentFactory];
        }("full-sheet-necessary-dialog-layer"),
        [y, h] = (0, s.useState)(t),
        [v, g] = (0, s.useState)(a),
        [b, k] = (0, s.useState)(0),
        [S, x] = (0, s.useState)(0 === a),
        [w, D] = (0, s.useState)(a === m.length - 1),
        C = (0, s.useRef)([]),
        G = s.default.useRef(null),
        I = (0, s.useRef)([]),
        M = E.bind(J),
        L = M("button-container"),
        A = M("closeButton"),
        T = M("upButton"),
        z = (M("upButtonDisabled"), M("downButton")),
        $ = M("video-reel"),
        U = M("button-container-wrapper"),
        B = M("container"),
        N = M("content"),
        O = () => {
          h(!1), f.closeDialog(), o && o();
        };
      (0, s.useEffect)(() => {
        var e;
        g(e = a), C.current[e] && C.current[e].scrollIntoView({
          behavior: "auto",
          block: "start"
        });
      }, [a]);
      const V = e => {
        const t = m.length - 1;
        g(n => {
          let a = n;
          return e === c && n > 0 ? (i?.(), a = n - 1) : e === d && n < t && (n === t - 2 && l?.(), r?.(), a = n + 1), x(0 === a), D(a === t), setTimeout(() => {
            var e;
            e = a, C.current[e] && C.current[e].scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }, 0), a;
        });
      };
      return (0, s.useEffect)(() => {
        const e = e => {
          switch (e.key) {
            case "ArrowUp":
              S || V(c);
              break;
            case "ArrowDown":
              w || V(d);
              break;
            case "Escape":
              O();
          }
        };
        return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
      }, [S, w, v]), s.default.createElement(s.default.Fragment, null, s.default.createElement(F.EGDSSheetTransition, {
        isVisible: y
      }, s.default.createElement(F.EGDSSheet, {
        liveAnnounceString: "Full Sheet has opened",
        type: "full",
        isVisible: p,
        triggerRef: G,
        theme: "dark",
        className: B,
        autoFocus: !0
      }, !n && s.default.createElement(F.EGDSTransparentToolbar, {
        overlay: !0,
        navigationContent: {
          onClick: O,
          navIconLabel: u?.closeAccessibility || "Close Travel Videos"
        }
      }), s.default.createElement(F.EGDSSheetContent, {
        className: N,
        fullSheetContentMaxWidth: "extra-large"
      }, m.length > 1 && s.default.createElement(F.EGDSLayoutFlex, {
        className: U
      }, s.default.createElement(F.EGDSLayoutFlex, {
        className: L
      }, s.default.createElement(F.EGDSTertiaryButton, {
        className: ` ${T}`,
        type: "button",
        onClick: () => V(c),
        id: "car-up-button",
        title: "Scroll up",
        size: F.EGDSButtonSize.MEDIUM,
        "aria-label": u?.pagingControls?.previousAccessibility,
        disabled: S
      }, s.default.createElement(F.EGDSIcon, {
        name: "arrow_upward_iOS",
        size: F.EGDSIconSize.MEDIUM
      })), s.default.createElement(F.EGDSTertiaryButton, {
        className: ` ${z}`,
        type: "button",
        onClick: () => V(d),
        id: "car-down-button",
        title: "Scroll down",
        size: F.EGDSButtonSize.MEDIUM,
        "aria-label": u?.pagingControls?.nextAccessibility,
        disabled: w
      }, s.default.createElement(F.EGDSIcon, {
        name: "arrow_downward_iOS",
        size: F.EGDSIconSize.MEDIUM
      })))), n && s.default.createElement(F.EGDSTertiaryButton, {
        className: A,
        type: "button",
        onClick: O,
        id: "mobile-close-button",
        title: "mobile-close-button",
        size: F.EGDSButtonSize.MEDIUM,
        "aria-label": u.closeAccessibility
      }, s.default.createElement(F.EGDSIcon, {
        name: "close",
        size: F.EGDSIconSize.MEDIUM
      })), s.default.createElement(F.EGDSLayout, null, m.map((e, t) => s.default.isValidElement(e) ? s.default.createElement("div", {
        key: `index=${t}`,
        className: $,
        id: `carousel-item-${t}`,
        ref: e => {
          C.current[t] = e;
        }
      }, s.default.cloneElement(e, {
        ref: e => {
          e && (I.current[t] = e);
        }
      })) : null))))));
    };
  K.displayName = "CarouselVerticalNavigation";
  const ee = (e => {
      var t = {};
      return c.d(t, e), t;
    })({
      classNames: () => l.classNames
    }),
    te = c.p + "./styles/egds-one-graph-avatar-themed.css",
    ne = ee.classNames.bind(te),
    ae = e => {
      const {
          border: t,
          size: n,
          image: a,
          text: o,
          icon: i,
          className: r,
          theme: l
        } = e,
        u = "uitk-avatar",
        c = ne(u, {
          [`${u}-${n}`]: n
        }, {
          [`${u}-hasborder`]: t
        }, r);
      return a ? s.createElement("img", {
        className: ne(c, `${u}-image`),
        src: a.src,
        alt: a.alt
      }) : o ? s.createElement("div", {
        className: ne(c, `${u}-text`, `${u}-text-${n}`, `${u}-text-${l}`)
      }, o) : i ? s.createElement("div", {
        className: ne(c, `${u}-icon`, `${u}-icon-${n}`, `${u}-icon-${l}`)
      }, s.createElement(O.EGDSIcon, {
        name: i,
        size: n
      })) : s.createElement("div", {
        className: ne(c, `${u}-placeholder`)
      });
    };
  ae.defaultProps = {
    size: "medium",
    border: !1
  }, ae.displayName = "AvatarThemed";
})();
var m = d.Eh,
  p = d.mw,
  f = d.mZ,
  y = d.vZ,
  h = d.tQ,
  v = d.aT;
export { m as AvatarCustom, p as AvatarThemed, f as CarouselVerticalNavigation, y as ImageEditor, h as VideoGestureControls, v as preDefinedProps };